const initAuthorSort = () => {
    const dropdownBtn = document.querySelector('.dropdown-btn');
    const dropdownContent = document.querySelector('#dropdown-content');
    const form = document.querySelector('#filter-form');
    const categoryInput = document.querySelector('#category-input');
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('po_cat_filter');

    if (!dropdownBtn || !dropdownContent || !form) {
        return;
    }

    if (category) {
        const selectedElement = document.querySelector(`#dropdown-content div[data-value="${category}"]`);
        if (selectedElement) {
            document.querySelector('#selected-category').textContent = selectedElement.textContent;
        }
    }

    if (!urlParams.get('po_cat_filter') && !urlParams.get('order')) {
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    dropdownBtn.addEventListener('click', function(e) {
        e.preventDefault();
        dropdownContent.classList.toggle('show');
        dropdownBtn.parentElement.classList.toggle('open');
    });

    dropdownContent.addEventListener('click', function(e) {
        const element = e.target.closest('div');
        if (element && element.dataset.value !== undefined) {
            document.querySelector('#selected-category').textContent = element.textContent;
            if (element.dataset.value === "") {
                categoryInput?.removeAttribute('name');
            } else {
                categoryInput?.setAttribute('name', 'po_cat_filter');
                categoryInput.value = element.dataset.value;
            }
            dropdownContent.classList.remove('show');
            dropdownBtn.parentElement.classList.remove('open');
            form.submit();
        }
    });

    document.addEventListener('click', function(e) {
        if (!dropdownBtn.contains(e.target) && !dropdownContent.contains(e.target)) {
            dropdownContent.classList.remove('show');
        }
    });

    document.querySelectorAll('.po-radio-btn__input').forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.value === 'desc' && !urlParams.has('order')) {
                urlParams.delete('order');
                window.history.replaceState({}, document.title, window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : ''));
            }
            form.submit();
        });
    });
};

export { initAuthorSort };